import styled from '@emotion/styled';
import { spacing, borderRadius, breakpoints } from '@naf/theme';
import { Text } from '@naf/text';
import { Link } from 'react-router-dom';

export const PickupBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${spacing.space16};
  border: 1px solid #d0d0d0;
  border-radius: ${borderRadius.M};
  margin-top: ${spacing.space16};
  gap: ${spacing.space16};

  @media (max-width: ${breakpoints.m}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const PickupBoxContent = styled.div`
  flex: 1;

  h4 {
    margin: 0 0 ${spacing.space8} 0;
  }

  p {
    margin: 0;
  }
`;

export const InfoBox = styled.div`
  padding: ${spacing.space16};
  border: 1px solid #d0d0d0;
  border-radius: ${borderRadius.M};
  margin-top: ${spacing.space16};

  p {
    margin: 0;
  }
`;

export const NAFCentersLink = styled(Link)``;

export const PickupTitle = styled(Text)`
  margin: 0;
`;
